import LandingPage from '../pages/LandingPage.vue';

const SearchPage = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "SearchPage" */ '../pages/SearchPage.vue');

const MerchantListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "MerchantListPage" */ '../pages/MerchantListPage.vue');
const MerchantDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "MerchantDetailPage" */ '../pages/MerchantDetailPage.vue');
const CoursesFilter = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "CoursesFilter" */ '../components/SearchPage/CoursesFilter.vue');
const CoursesSort = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "CoursesSort" */ '../components/SearchPage/CoursesSort.vue');
const CoursesLocation = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "CoursesLocation" */ '../components/SearchPage/CoursesLocation.vue');

const CategoryListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "CategoryListPage" */ '../pages/CategoryListPage.vue');
const CategoryDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "CategoryDetailPage" */ '../pages/CategoryDetailPage.vue');

const CourseListPage = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CourseListPage" */ '../pages/CourseListPage.vue');

const DetailPage = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "DetailPage" */ '../pages/DetailPage.vue');

const TermsAndConditionPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "TermsAndConditionPage" */ '../pages/TermsAndConditionPage.vue');

const TransactionListPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "TransactionListPage" */ '../pages/TransactionListPage.vue');

const TransactionDetailPage = () =>
  import(/* webpackPrefetch: true */ /* webpackChunkName: "TransactionDetailPage" */ '../pages/TransactionDetailPage.vue');

const PurchasePage = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "PurchasePage" */ '../pages/PurchasePage.vue');

const routes = [
  {
    name: 'landing',
    path: '/',
    component: LandingPage,
  },
  {
    name: 'search',
    path: '/pencarian',
    component: SearchPage,
    children: [
      {
        name: 'search-filter',
        path: 'filter',
        component: CoursesFilter,
      },
      {
        name: 'search-sort',
        path: 'sort',
        component: CoursesSort,
      },
      {
        name: 'search-location',
        path: 'location',
        component: CoursesLocation,
      },
    ],
  },
  {
    name: 'dynamic-section',
    path: '/section/:section_category/:section_slug',
    component: CourseListPage,
  },
  {
    name: 'merchants',
    path: '/lembaga',
    component: MerchantListPage,
  },
  {
    name: 'tnc',
    path: '/tnc',
    component: TermsAndConditionPage,
  },
  {
    name: 'merchant-detail',
    path: '/lembaga/:id',
    component: MerchantDetailPage,
    children: [
      {
        name: 'merchant-search-filter',
        path: 'filter',
        component: CoursesFilter,
      },
      {
        name: 'merchant-search-sort',
        path: 'sort',
        component: CoursesSort,
      },
      {
        name: 'merchant-search-location',
        path: 'location',
        component: CoursesLocation,
      },
    ],
  },
  {
    name: 'categories',
    path: '/kategori',
    component: CategoryListPage,
  },
  {
    name: 'purchase',
    path: '/purchase/:id',
    component: PurchasePage,
  },
  {
    name: 'category',
    path: '/kategori/:id',
    component: CategoryDetailPage,
  },
  {
    name: 'transaksi',
    path: '/transaksi',
    component: TransactionListPage,
  },
  {
    name: 'detail-transaksi',
    path: '/transaksi/:id',
    component: TransactionDetailPage,
  },
  {
    name: 'detail',
    path: '/:id',
    component: DetailPage,
  },
  {
    path: '*',
    redirect: '/',
  },
];

export default routes;
